import {ENTRY_ANIMATION_MS} from './entryTimeline.mjs';

// Track native SVG/CSS animations instead of guessing when an image finishes.
export function playBrandIntro(root,{duration=ENTRY_ANIMATION_MS,elapsed=0,reducedMotion=false,onReady=()=>{},onComplete=()=>{}}={}) {
  let disposed=false;
  if(reducedMotion){onReady();onComplete();return ()=>{disposed=true;};}
  const animations=root.getAnimations?.({subtree:true}) || [];
  const position=Math.max(0,Math.min(duration,elapsed));
  for(const animation of animations){
    animation.pause();
    animation.effect.updateTiming({duration,iterations:1,fill:'forwards'});
    animation.currentTime=position;
    if(position<duration)animation.play();
  }
  onReady();
  if(position===duration)onComplete();
  // Older browsers without getAnimations use the workspace's timeout fallback.
  else if(animations.length)Promise.all(animations.map(animation=>animation.finished)).then(()=>{
    if(!disposed)onComplete();
  }).catch(()=>{ /* Unmounting cancels the old animation; it must not end a new intro. */ });
  return ()=>{disposed=true;for(const animation of animations)animation.cancel();};
}
